export default {
  menuItem: {
    account: '账户信息',
    billing: '账单设置',
    appearance: '界面设置',
    organization: '机构管理',
    logout: '退出登录',
  }
}